import { pick, serverMap } from '@/shared/lib/server-map'
import type { BookingDetail } from '@/shared/api'
import type { IconName } from '@/shared/ui'

// Типы выведены из контракта индексным доступом: схема лежит в `BookingDetail` инлайном, и
// рукописная копия разъехалась бы с ней молча.
export type BookingActionCard = BookingDetail['actionsRequired'][number]
export type BookingActionKind = BookingActionCard['kind']
export type BookingActionButton = BookingActionCard['actions'][number]

// Незнакомый вид — серый со знаком вопроса: любой цвет из `KMETA` ЗАЯВИЛ БЫ вид, которого мы не
// распознали. Правило целиком — в `model/server-drift.ts`.
const FALLBACK_TOKEN = 'var(--ink-3)'
const FALLBACK_ICON: IconName = 'alert'

/**
 * Вид действия → токен цвета плитки. Значения из скрипта макета — `KMETA`
 * (`prototype/Prototype.dc.html:6130`), а не подобраны на глаз.
 *
 * ⚠️ `docs` В КАРТЕ НЕТ НАМЕРЕННО: контракт такого вида не знает, сервер его не пришлёт, и карточка
 * «Подтвердите документы» из макета не рисуется вовсе — она заявляла бы, что гость ЭТОЙ брони
 * прислал документы (план фазы 2, «Осознанные отступления», п. 1).
 */
const KIND_TOKENS = serverMap({
  pay: 'var(--st-pending)',
  checkin: 'var(--st-confirmed)',
  decision: 'var(--st-pending)',
  deposit: 'var(--st-in)',
})

export function actionKindToken(kind: BookingActionKind): string {
  return pick(KIND_TOKENS, kind, FALLBACK_TOKEN)
}

// В макете иконка есть только у `pay` (рубль) — остальные три нарисованы нами в его языке и лежат в
// `shared/ui/icon/icons.tsx`. Сервер отдаёт СМЫСЛ, фронт выбирает цвет и рисунок.
const KIND_ICONS = serverMap<IconName>({
  pay: 'ruble',
  checkin: 'checkin',
  decision: 'decision',
  deposit: 'deposit',
})

export function actionKindIcon(kind: BookingActionKind): IconName {
  return pick(KIND_ICONS, kind, FALLBACK_ICON)
}

/**
 * Действие без заголовка, описания И кнопок — пустая плитка «требует вашего действия», где нечего
 * прочитать и негде нажать (так приходит, например, авто-шаг движка). Пусто значит «нет действия».
 */
export function isRenderableBookingAction(action: BookingActionCard): boolean {
  return (
    action.title.trim() !== '' ||
    action.description.trim() !== '' ||
    action.actions.length > 0
  )
}
